export default "__VITE_ASSET__CKy4KjV8__"